app.mapsController = app.mapsController || {};

app.mapsController.indexAction = {

    /**
     * Initialisation de la fonction
     */
    init : function () {
        this.create();
    },

    style : function () {
        return [
            {"featureType":"all","elementType":"all","stylers":[{"invert_lightness":true},{"saturation":-100}]},
            {"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},
            {"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#00ff99"}]},
            {"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#00ff99"}]},
            {"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#eeeeee"}]},
            {"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},
            {"featureType":"road.local","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#000000"}]}];
    },

    create : function () {
        if($('#gMap').length) {
            var map = L.map('gMap').setView([49.437538, 1.096769], 17,);
            L.tileLayer.provider('CartoDB.Voyager').addTo(map);

            var n = L.icon({
                iconUrl: "/content/themes/arcange-site2016/img/logo-gmap.svg",
                iconSize: [56, 70],
                iconAnchor: [28, 70]
            });
            new L.marker([49.437538, 1.096769],{
                icon: n
            }).addTo(map).bindPopup("<p class='infoWindow'><strong>Arcange</strong><br />1 rue de quebec<br />76000 Rouen<br />FRANCE</p>")
        }
    }

};
